<template>
  <div class="useral-answer-ticket-footer">
    <div class="attaches-files-list" v-if="ticket.attaches.length > 0">
      <template v-for="(attach, key) in ticket.attaches">
        <div :key="key" class="attach-file-preview">
          <div class="attach-name">
            {{ attach.name }}
          </div>
          <div class="clear-attach" @click="ticket.attaches.splice(key, 1)">
            <custom-icon icon="xmark-icon" height="20px" width="20px" color="danger" />
          </div>
        </div>
      </template>
    </div>
    <div class="answer-ticket-row">
      <div class="send-answer" @click="sendData">
        <custom-icon icon="paper-plane-top-icon" height="30px" width="30px" />
      </div>
      <div class="message-input">
        <custom-validate-textarea :placeholder="$t('tickets.general.placeholder.message')"
                                  ref="chatInput"
                                  :classes="{'w-full': true}"
                                  align="right"
                                  rtl
                                  is-empty
                                  @input="handleResizeTextarea"
                                  @pressEnter="sendData"
                                  v-model="ticket.message"/>
      </div>

      <div class="attach-btn">
        <custom-icon icon="paperclip-icon" height="30px" width="30px" />

        <input type="file"
               ref="fileInput"
               @change="handleInputValue">
      </div>
    </div>

    <vs-button v-show="false"
               id="answerTicketBTN"
               @click="sendData"/>
  </div>
</template>

<script>
import axios from 'axios'
import CustomValidateInput from '@/components/input/customValidateInput'
import CustomValidateTextarea from '@/components/input/customValidateTextarea'
import CustomFileInput from '@/components/input/customeFileInput'
import CustomIcon from '@/components/icon/customIcon'
import {sendMessageTicket} from '@/http/requests/tickets'

export default {
  name: 'AnswerTicket',
  components: {
    CustomIcon,
    CustomFileInput,
    CustomValidateTextarea,
    CustomValidateInput
  },
  data () {
    return {
      suggestServicePromptStatus: false,
      ticket: {
        message: {
          value: '',
          isValid: false
        },
        attaches: []
      }
    }
  },
  mounted () {
    this.handleResizeTextarea()
  },
  methods: {
    handleInsertAttachInput () {
      this.ticket.attaches.push({
        file: {
          value: '',
          isValid: true
        }
      })
    },
    handleResizeTextarea () {
      const minHeight = 30
      const maxHeight = 150

      const textareaElement = this.$refs.chatInput.$refs.textarea
      // set height to auto to let the browser calculate the true content height
      textareaElement.style.height = 'auto'
      // we need to add one pixel because of Firefox shenanigans
      let contentHeight = textareaElement.scrollHeight + 1
      // set to minimum height
      contentHeight = Math.max(contentHeight, minHeight)
      // set to maximum height, if given
      if (maxHeight) {
        contentHeight = Math.min(contentHeight, maxHeight)
      }
      textareaElement.style.height = `${contentHeight}px`
    },
    sendData () {
      if (!this.ticket.message.isValid) {
        this.$vs.notify({
          title: this.$t('others.alert.error.title'),
          text: this.$t('tickets.general.validators.message'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.validators.message')),
          color: 'danger'
        })
        return false
      }

      const attaches = []
      const formData = new FormData()
      let attachCount = 0
      this.ticket.attaches.forEach((attach) => {
        if (attach.file.value) {
          attaches.push(formData)
          formData.append(`attachments[${attachCount}]`, attach.file.value)
          attachCount++
        }
      })

      formData.append('message', this.ticket.message.value)

      sendMessageTicket(this.$route.params.id, formData).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('tickets.general.notifications.sendMessage.success'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.notifications.sendMessage.success')),
          color: 'success'
        })
        this.ticket = {
          message: {
            value: '',
            isValid: false
          },
          attaches: []
        }
        this.$nextTick(() => {
          this.handleResizeTextarea()
        })

        this.$emit('insert')
      }).catch((error) => {
        if (axios.isCancel(error)) {
          this.$vs.notify({
            title: this.$t('others.alert.duplicateRequest.title'),
            text: this.$t('others.alert.duplicateRequest.message'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: this.$u.getReadingTime(this.$t('others.alert.duplicateRequest.message')),
            color: 'warning'
          })
        } else {
          const error_mapper = {
            'message': this.$t('tickets.general.notifications.parseError.message'),
            'attachments': this.$t('tickets.general.notifications.parseError.attachments')
          }

          switch (error.response.status) {
          case 422:
            Object.keys(error.response.data.errors).forEach((error_key) => {
              const err = error_key.toString().split('.')
              if (error_mapper[err[err.length - 1]]) {
                this.$vs.notify({
                  title: this.$t('others.alert.error.title'),
                  text: error_mapper[err[err.length - 1]],
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(error_mapper[err[err.length - 1]])
                })
                error_mapper[err[err.length - 1]] = null
              } else if (error_mapper[err[0]]) {
                this.$vs.notify({
                  title: this.$t('others.alert.error.title'),
                  text: error_mapper[err[0]],
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(error_mapper[err[0]])
                })
                error_mapper[err[0]] = null
              }
            })
            break

          default:
            this.$vs.notify({
              title: this.$t('others.alert.error.title'),
              text: this.$t('tickets.general.notifications.sendMessage.error'),
              color: 'danger',
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('tickets.general.notifications.sendMessage.error'))
            })
            break
          }
        }
      })
    },
    handleInputValue (e) {
      const inputValue = e.target.files[0]
      if (inputValue.size <= 512000) {
        // this.validateValue()
        this.ticket.attaches.push({
          name: inputValue.name,
          file: {
            value: inputValue,
            isValid: true
          }
        })

      } else {
        this.$vs.notify({
          title: this.$t('others.alert.error.title'),
          text: this.$t('components.customFileInput.sizeError', {size: 512}),
          color: 'danger',
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('components.customFileInput.sizeError', {size: 512}))
        })
      }

      this.$refs.fileInput.value = null
    }
  }
}
</script>

<style lang="scss">
  .useral-answer-ticket-footer {
    border-top: 1px solid #cdcdcd;
    background-image: linear-gradient(#f0f0f0, #f5f5f5, #ffffff);
    width: 100%;

    .attaches-files-list {
      padding: 5px;
      max-height: 150px;

      .attach-file-preview {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin-bottom: 5px;
        border: 1px solid #cdcdcd;
        border-radius: 6px;
        background-color: #f8f8f8;

        .clear-attach:hover {
          cursor: pointer;
        }

        &:before {
          content: ' ';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          height: 100%;
          width: 5px;
          background-color: #555555;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .answer-ticket-row {
      display: flex;
      align-items: flex-end;
      width: 100%;
      padding-bottom: 5px;

      &.dir-rtl {
        flex-direction: row;
      }

      .send-answer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        margin-bottom: 5px;

        &:hover {
          cursor: pointer;
        }
      }

      .message-input {
        width: calc(100% - 80px);

        .custom-validate-input {
          margin: 0;

          .u-input-box {
            display: flex;
            padding: 0;
            min-height: unset;
            background-color: transparent;

            .u-input-label-box {
              & > div {
                border-color: transparent;
              }
            }
          }

          textarea {
            padding: 6px 5px;
          }
        }
      }

      .attach-btn {
        position: relative;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;

        &:hover,
        & > *:hover {
          cursor: pointer;
        }

        input[type=file] {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 100%;
          width: 100%;
          opacity: 0;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
